import { type ReactElement } from "react";

import { styled } from "simplydo/react/styled";

import { Checkbox } from "../checkbox/Checkbox";
import type { FormCheckboxProps } from "./Form.types";

const FormCheckboxComponent = (props: FormCheckboxProps): ReactElement => {
  return <Checkbox {...props} />;
};

export const FormCheckbox = styled(FormCheckboxComponent)``;
